import { useRef } from "preact/hooks";

import { useFocusHeadingOnMount } from "../hooks/useFocusHeadingOnMount";
import { TOKEN_INVALID_BODY, TOKEN_INVALID_HEADING } from "../lib/authCopy";

/**
 * Sprint-007 D6 (UX §3.4, ADR-002 A4-R6) — shown when a stale/expired/
 * already-consumed/revoked magic link is tapped. "Same visual family as
 * the existing `logged-out-screen` CSS class (centered, serif heading,
 * calm — reuse the class, do not invent a new one)... This is the one
 * place the old 'ask for your link' framing survives verbatim, because
 * it's the one place it's still exactly true."
 */
export function TokenInvalidView() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useFocusHeadingOnMount(headingRef);

  return (
    <div class="logged-out-screen">
      <span class="app-wordmark">Hayloft</span>
      <h1 ref={headingRef} tabIndex={-1} class="logged-out-heading">
        {TOKEN_INVALID_HEADING}
      </h1>
      <p class="logged-out-copy">{TOKEN_INVALID_BODY}</p>
    </div>
  );
}
